import comp from "./CreateAssignmentModal";
export default comp;
